// import React from "react";
// import "./ProductDetail1.css";
// import { Link } from "react-router-dom";
// import Gfooter from "../Component/Gfooter";

// function ProductDetail1() {
//   return (
//     <>
//       <section className="product-detail">

//         {/* 🔥 HERO SECTION */}
//         <div className="product-hero">
//           <div className="container text-center">
//             <h1 data-aos="zoom-in">Global Port Management System</h1>
//             <p data-aos="fade-up" data-aos-delay="200">
//               Smart, scalable and efficient solution to manage port operations
//               with precision and performance.
//             </p>
//           </div>
//         </div>

//         {/* 💡 MAIN CONTENT */}
//         <div className="container product-detail-content">
//           <div className="row align-items-center">

//             {/* IMAGE */}
//             <div className="col-lg-6" data-aos="fade-right">
//               <img
//                 src="/project-pic/portmanagement.jpg"
//                 alt="port"
//                 className="img-fluid detail-img"
//               />
//             </div>

//             {/* TEXT */}
//             <div className="col-lg-6" data-aos="fade-left">
//               <h2>About the System</h2>
//               <p>
//                 Managing terminal operations in the maritime industry demands
//                 efficiency and cost-effectiveness. Our Global Port Management
//                 System (GPMS) is designed to streamline workflows, optimize
//                 logistics, and reduce operational costs.
//               </p>

//               <ul>
//                 <li>✔ Real-time port operations tracking</li>
//                 <li>✔ Cargo & vessel management</li>
//                 <li>✔ Automated reporting system</li>
//                 <li>✔ High security & scalability</li>
//               </ul>

//               <Link to="/contact-us">
//                 <button className="demo-btn">Request Demo</button>
//               </Link>
//             </div>

//           </div>
//         </div>

//         {/* 🚀 FEATURES SECTION */}
//         <div className="features-section">
//           <div className="container text-center">
//             <h2 data-aos="zoom-in">Key Features</h2>

//             <div className="row mt-5">

//               <div className="col-md-4" data-aos="fade-up">
//                 <div className="feature-box">
//                   <h4>Automation</h4>
//                   <p>Reduce manual work with smart automation tools.</p>
//                 </div>
//               </div>

//               <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
//                 <div className="feature-box">
//                   <h4>Analytics</h4>
//                   <p>Powerful insights to improve operational efficiency.</p>
//                 </div>
//               </div>

//               <div className="col-md-4" data-aos="fade-up" data-aos-delay="400">
//                 <div className="feature-box">
//                   <h4>Integration</h4>
//                   <p>Seamlessly integrates with existing systems.</p>
//                 </div>
//               </div>

//             </div>
//           </div>
//         </div>

//         {/* 🎯 CTA SECTION */}
//         <div className="cta-section text-center">
//           <h3 data-aos="zoom-in">
//             Ready to transform your port operations?
//           </h3>

//           <Link to="/contact-us">
//             <button className="cta-btn">Get Started</button>
//           </Link>
//         </div>

//       </section>

//       <Gfooter />
//     </>
//   );
// }

// export default ProductDetail1;


import React from "react";
import "./ProductDetail1.css";
import { Link } from "react-router-dom";
import Gfooter from "../Component/Gfooter";

function ProductDetail1() {
  return (
    <>
      <section className="product-detail">

        {/* 🔥 HERO */}
        <div className="product-hero">
          <div className="container text-center">
            <h1 data-aos="zoom-in">Global Port Management System</h1>
            <p data-aos="fade-up" data-aos-delay="200">
              Transforming port operations with smart automation & real-time insights
            </p>
          </div>
        </div>

        {/* 💡 ABOUT */}
        <div className="container product-detail-content">
          <div className="row align-items-center">

            <div className="col-lg-6" data-aos="fade-right">
              <img
                src="/project-pic/portmanagement.jpg"
                alt="port"
                className="img-fluid detail-img"
              />
            </div>

            <div className="col-lg-6" data-aos="fade-left">
              <h2>About System</h2>
              <p>
                Managing terminal operations in the maritime industry demands efficiency and cost-effectiveness.
                Our Global Port Management System (GPMS) streamlines terminal operations, enhances logistics,
                and reduces operational costs with intelligent automation.
              </p>

              <Link to="/contact-us">
                <button className="demo-btn">Request Demo</button>
              </Link>
            </div>

          </div>
        </div>

        {/* 🚀 FEATURES (FROM ReadMore) */}
        <div className="features-section">
          <div className="container">
            <h2 className="text-center" data-aos="zoom-in">Key Features</h2>

            <div className="row mt-5">

              <div className="col-md-6" data-aos="fade-up">
                <div className="feature-box">
                  <h4>Comprehensive Operational View</h4>
                  <p>Real-time integration of all terminal operations for better visibility.</p>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
                <div className="feature-box">
                  <h4>Efficient Cargo Management</h4>
                  <p>Optimizes scheduling and improves cargo handling efficiency.</p>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                <div className="feature-box">
                  <h4>Container Yard Management</h4>
                  <p>Enhances container storage and movement efficiency.</p>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-up" data-aos-delay="300">
                <div className="feature-box">
                  <h4>Queue & Crane Optimization</h4>
                  <p>Improves workflow using smart queue and crane management.</p>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* 💰 BENEFITS (FROM ReadMore) */}
        <div className="benefits-section">
          <div className="container">
            <h2 className="text-center" data-aos="zoom-in">Benefits</h2>

            <div className="row mt-5">

              <div className="col-md-6" data-aos="fade-right">
                <div className="benefit-box">
                  <h4>Cost Savings</h4>
                  <p>Optimizes resources and reduces operational costs.</p>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-left">
                <div className="benefit-box">
                  <h4>Enhanced Efficiency</h4>
                  <p>Improves turnaround time and workflow automation.</p>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-right" data-aos-delay="200">
                <div className="benefit-box">
                  <h4>Real-time Insights</h4>
                  <p>Data-driven decisions with powerful analytics.</p>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-left" data-aos-delay="200">
                <div className="benefit-box">
                  <h4>Competitive Advantage</h4>
                  <p>Stay ahead with advanced operational capabilities.</p>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* 🎯 CTA */}
        <div className="cta-section text-center">
          <h3 data-aos="zoom-in">
            Ready to optimize your port operations?
          </h3>

          <Link to="/contact-us">
            <button className="cta-btn">Get Started</button>
          </Link>
        </div>

      </section>

      <Gfooter />
    </>
  );
}

export default ProductDetail1;